<template v-cloak>
    <NuxtLayout name="main" dark class="bg-[#F7F6FB]">
        <div class="mx-auto my-[56px] px-[64px] py-[62px] w-[1264px] bg-white">
            <div class="text-[44px] leading-[62px] font-bold text-emphas">{{ $t("TimelyUpadated") }}</div>
            <div class="w-[132px] h-[4px] bg-main mt-[22px] mb-[46px]"></div>
            <div
                class="mb-[40px] pl-[80px] h-[240px] flex flex-col justify-center bg-[url(https://rdgta.cdn.cyagen.com/rddc/pictures/7fff305d-8187-4fa2-b250-be245f9a5e7a.webp)] font-bold text-white">
                <div v-if="$i18n.locale == 'en'">
                    <p class="text-[36px] leading-[52px]">{{ $t("TimelyUpadatedI18n.Name1") }}</p>
                    <p class="mt-[8px] text-[20px] leading-[36px] w-[660px]">{{ $t("TimelyUpadatedI18n.Name2") }}</p>
                </div>
                <div v-else>
                    <p class="text-[30px] leading-[46px]">{{ $t("TimelyUpadatedI18n.Name1") }}</p>
                    <p class="mt-[4px] text-[40px] leading-[56px]">{{ $t("TimelyUpadatedI18n.Name2") }}</p>
                </div>
            </div>
            <p class="text-[16px]">{{ $t("TimelyUpadatedI18n.Descript1") }}</p>
            <p class="text-[16px] mt-[24px]">{{ $t("TimelyUpadatedI18n.Descript2") }}</p>
            <p class="text-[16px] mt-[24px]">{{ $t("TimelyUpadatedI18n.Descript3") }}</p>
        </div>
    </NuxtLayout>
</template>
